import { createContext, useContext } from 'react';

/**
 * SIGILO DA LOJA NA TELA — custo e margem são dados do dono (`loja.ver`). O servidor já manda o
 * custo vazio para quem não é dono; aqui a tela ESCONDE o bloco (em vez de escrever
 * "indisponível", que sugere um problema). O App fornece o valor a partir do perfil da sessão.
 */
export const VeCusto = createContext(false);
export const useVeCusto = () => useContext(VeCusto);

/**
 * MODO "SÓ NÚMEROS" (Carlos, 08/10/2026): o balconista não vê quanto GANHA nem quanto VENDEU em
 * R$. O servidor já manda esses campos `null`; a tela usa isto para REMOVER a linha/o cartão (nunca
 * "R$ 0,00", nunca "—" no lugar). Preço do produto continua: ele precisa para vender.
 */
export const ValoresOcultos = createContext(false);
export const useValoresOcultos = () => useContext(ValoresOcultos);

/** Mostra a linha de dinheiro? Só se o modo permite E o servidor mandou o valor. */
export function mostraValor(ocultos: boolean, valor: string | number | null | undefined): boolean {
  return !ocultos && valor !== null && valor !== undefined && valor !== '';
}

/** Junta só as partes que existem (sem "·" sobrando quando o dinheiro some do meio). */
export function juntar(
  partes: readonly (string | false | null | undefined)[],
  separador = ' · ',
): string {
  return partes.filter((p): p is string => typeof p === 'string' && p !== '').join(separador);
}

/** Soma em centavos inteiros; `null` (valor oculto pelo servidor) não conta. Tudo oculto → `null`. */
export function somarReais(valores: readonly (string | null | undefined)[]): string | null {
  let centavos = 0;
  let algum = false;
  for (const v of valores) {
    if (v === null || v === undefined || v === '') continue;
    const [i = '0', d = ''] = v.split('.');
    centavos += Number(i) * 100 + Number((d + '00').slice(0, 2));
    algum = true;
  }
  if (!algum) return null;
  return `${String(Math.floor(centavos / 100))}.${String(centavos % 100).padStart(2, '0')}`;
}
